const STYLES = {
  // RDV
  a_planifier: ["À planifier", "#EEF0F4", "#475569"],
  planifie: ["Planifié", "#DBEAFE", "#1D4ED8"],
  arrive: ["Arrivé", "#E0F2FE", "#0369A1"],
  en_cours: ["En cours", "#FEF3C7", "#B45309"],
  termine: ["Terminé", "#DCFCE7", "#15803D"],
  termine_or: ["À facturer", "#FEF3C7", "#B45309"],
  // OR
  ouvert: ["Ouvert", "#DBEAFE", "#1D4ED8"],
  facture: ["Facturé", "#0E2A4E", "#FFFFFF"],
  // Facture
  brouillon: ["Brouillon", "#EEF0F4", "#475569"],
  validee: ["Validée", "#DCFCE7", "#15803D"],
  payee: ["Payée", "#0E2A4E", "#FFFFFF"],
  // Véhicule stock
  en_stock: ["En stock", "#DCFCE7", "#15803D"],
  reserve: ["Réservé", "#FEF3C7", "#B45309"],
  vendu: ["Vendu", "#DBEAFE", "#1D4ED8"],
  livre: ["Livré", "#0E2A4E", "#FFFFFF"],
  // Dossier
  offre: ["Offre", "#EEF0F4", "#475569"],
  bdc: ["BdC signé", "#DBEAFE", "#1D4ED8"],
  a_livrer: ["À livrer", "#DCFCE7", "#15803D"],
  // Origines facture
  or: ["Atelier", "#E0F2FE", "#0369A1"],
  vehicule: ["Véhicule", "#EDE9FE", "#6D28D9"],
  comptoir: ["Comptoir", "#FEF3C7", "#B45309"],
  // Types
  vn: ["VN", "#2F6FED", "#FFFFFF"],
  vo: ["VO", "#0E7490", "#FFFFFF"],
  vd: ["VD", "#6D28D9", "#FFFFFF"],
  mecanique: ["Mécanique", "#DBEAFE", "#1D4ED8"],
  carrosserie: ["Carrosserie", "#FFEDD5", "#C2410C"],
  facture_dossier: ["Facturé", "#0E2A4E", "#FFFFFF"],
};

export default function StatusBadge({ statut, label, testId }) {
  const [lbl, bg, fg] = STYLES[statut] || [statut, "#EEF0F4", "#475569"];
  return (
    <span className="pill" style={{ background: bg, color: fg }} data-testid={testId || `badge-${statut}`}>
      {label || lbl}
    </span>
  );
}
